export const environment = {
  production: true,
  name: 'prod:bfl',
  serviceBaseUrls: {
    DOMAIN01: 'https://apis-marketplace.bajajfinserv.in/app01',
    AEMURL: 'https://cms-api.bajajfinserv.in',
    AEMBANNERSURL: 'https://cms-api.bajajfinserv.in/content/dam/insurance-marketplace/insurance-mall-dj/healthinsuranceitems/Transaction_SuccessFailure_Page.json',
    PaymentSuccessURL: 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/paymentStatus',
    PaymentFailURL: 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/paymentStatus',
    resumeUrl: 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/customerLogin',
    kycSourceUrl: 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/moreaboutyou',
  },
  paymentScript: 'https://pay-marketplace.bajajfinserv.in/pay/assets/paymentjs/checkout.js',
  AnalyticsLink: '//assets.adobedtm.com/5fc97671c230/cd5e6eefeb83/launch-a54325503df1-development.min.js',
  bflJourney: true,
  paymentFirstCall: 'https://apis-marketplace.bajajfinserv.in/app01/',
  paymentSecondCall: 'https://pay-marketplace.bajajfinserv.in/',
  isCleverTapEnabled: true,
  restrictEditAction: true,
  clevertapId: {
    web: ' W86-ZK8-K66Z',
    app: 'R9K-97K-8Z6Z'
  }
};

